import { memo } from 'react';
import Slider from '../../../SliderTwo';
import Button from '../../../Button';
import PublicationStatusBadge from '../PublicationStatusBadge/PublicationStatusBadge';
import { images } from '../../../../constants/images';
import styles from '../../publicationDetail.module.scss';
import { PublicationImageSliderProps } from '../../interfaces';

const PublicationImageSlider = ({
  type,
  brand,
  publication,
  selectedVersion,
  onLinzeCheckClick,
  vehicleTypeSelected,
  loading
}: PublicationImageSliderProps) => {
  const getSliderImages = () => {
    if (brand && selectedVersion && publication?.versions) {
      const selectedVehicle = publication.versions.find((v: any) => v.id === selectedVersion);
      const allImages = [];

      // Primero agregamos las imágenes principales de la publicación
      if (publication?.pictures && publication.pictures.length > 0) {
        const mainImages = publication.pictures.map((item: any, index: number) => (
          <img
            loading="lazy"
            key={`main-${index}`}
            src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url}
            className={publication?.paused && styles.paused}
            alt={`${publication?.title} ${publication.version ?? ""} año ${publication.year}`}
          />
        ));
        allImages.push(...mainImages);
      }

      // Luego agregamos las imágenes del vehículo seleccionado
      if (selectedVehicle?.images && selectedVehicle.images.length > 0) {
        const vehicleImages = selectedVehicle.images.map((item: any, index: number) => (
          <img
            loading="lazy"
            key={`vehicle-${index}`}
            src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url}
            className={publication?.paused && styles.paused}
            alt={`${publication?.title} ${selectedVehicle.version || selectedVehicle.name || ''} año ${selectedVehicle.year || publication?.year}`}
          />
        ));
        allImages.push(...vehicleImages);
      }

      return allImages.length > 0 ? allImages : [1].map((_: any, index: number) => (
        <img loading="lazy" key={index} src={images.noImagePublication} alt="No image found publication linzecar" />
      ));
    }

    return publication?.pictures && publication?.pictures.length > 0
      ? publication?.pictures.map((item: any, index: number) => (
          <img
            loading="lazy"
            key={index}
            src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url}
            className={publication?.paused && styles.paused}
            alt={`${publication?.title} ${publication.version ?? ""} año ${publication.year}`}
          />
        ))
      : [1].map((_: any, index: number) => (
          <img loading="lazy" key={index} src={images.noImagePublication} alt="No image found publication linzecar" />
        ));
  };

  return (
    <div className={styles.sliderContainer}>
      {/* iCar Overlay */}
      {type !== "myPublication" && !brand && vehicleTypeSelected !== "new" && (
        <div className={styles.icarOverlay} onClick={onLinzeCheckClick}>
          <span>
            <img src={images.icarIcon} alt="iCar" className={styles.icarIcon} />
            <Button
              title="Adquirir informe técnico"
              onPress={onLinzeCheckClick}
              tertiary
              size='small'
              className={`${styles.btnInformeOverlay} ${styles.customButton}`}
            />
          </span>
        </div>
      )}

      {/* Status Badge */}
      <PublicationStatusBadge
        publication={publication}
        type={type}
      />

      <Slider
        className={styles.slider}
        type="thumbs"
        options={getSliderImages()}
        pagination
        typePublication={type}
        loading={loading && (!Array.isArray(publication?.pictures) && !publication?.pictures?.length)}
      />
    </div>
  );
};

export default memo(PublicationImageSlider);
